import React from 'react';
import styles from './DetailHeader.module.css';

export default function DetailHeader({ title, badges, onBack, onRefresh, actions }) {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        {onBack && (
          <button onClick={onBack} className={styles.backButton} aria-label="Voltar">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </button>
        )}
        <h1 className={styles.title}>{title}</h1>
        {badges && <div className={styles.badges}>{badges}</div>}
      </div>
      {(onRefresh || actions) && (
        <div className={styles.actions}>
          {onRefresh && (
            <button onClick={onRefresh} className={styles.refreshButton} aria-label="Atualizar" title="Atualizar">
              <i className="fa fa-sync-alt" />
            </button>
          )}
          {actions}
        </div>
      )}
    </div>
  );
}
